import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph,
    Button
} from '../../components/RegularComponents'
import TopNavigationBar from "../TopNavigationBar"
import { useState } from 'react';
import {humanReadableDate, replaceUrlParams} from '../../app/utils'
import {collectorsReviewSelect} from '../../redux/selector/collectorsReviewSelector'
import Navigation from '../Navigation';
import { 
    doNotRenewIndividualApplications,
    renewIndividualApplications, 
    syncRjscDetailsForIndividualApplications
} from '../../redux/slice/businessLicenceApplicationSlice';
import { 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT 
} from '../../app/constants';

const CollectorsReview = (props) => {
    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params

    const collectors = props.collectorsReview.collectors ? 
                props.collectorsReview.collectors : []

    const collectorsReviewViewData = props.collectorsReview[applicationType] ? 
                    props.collectorsReview[applicationType] : props.collectorsReview
    
    const [collectorsCheckboxMapping, setCollectorsCheckboxMapping] = useState(collectors.map((c) => !c.markedDoNotRenew))

    return (
        <div>
            <Navigation {...props} />
            <div className={"container"}>
            <TopNavigationBar {...props} />
                <div className="row bottomMarginMedium">
                    <Header 
                        id="collectors-review-header"
                        header={collectorsReviewViewData.header} />
                </div>
                <div className="row">
                    <Paragraph 
                        id="collector-review-text" 
                        text={[
                            `Check the individual ${applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY ? 
                                'debt management agents' : 'collectors'} licences you want to renew. 
                                ${applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY ? 
                                    'Debt managent agent' : 'Collector'} licences you do not select will expire on 
                                    ${humanReadableDate(props.collectorsReview.renewalEndDate)} and not be valid after that date.`
                        ]} />
                </div>
                <div className="row">
                    <Paragraph 
                        style={{fontStyle: 'italic'}}
                        id="collector-review-summary-text" 
                        text={[
                            `${collectorsCheckboxMapping.filter(v => v).length} selected out of ${collectorsCheckboxMapping.length} total`
                        ]} />
                </div>
                {collectors.length > 0 ?
                 <div className="row">
                    <div className="col-8">
                        <fieldset className="ns-fieldset">
                            <div className=" ns-checkboxes">
                                {collectors.map((c, index) => {
                                    return (
                                        <div className="ns-checkboxes__item topMarginMedium" key={"collectors-checkbox-item-" + index}>
                                            <input 
                                                className="ns-checkboxes__input"
                                                id={"collectors-checkbox-input-" + index}
                                                name={"collectors-checkbox-input-" + index}
                                                key={"collectors-checkbox-input-" + index}
                                                type={"checkbox"}
                                                defaultChecked={collectorsCheckboxMapping[index]}
                                                value={collectorsCheckboxMapping[index]}
                                                onChange={() => {
                                                    let values = [...collectorsCheckboxMapping]
                                                    values[index] = !values[index]
                                                    setCollectorsCheckboxMapping(values)
                                                }} />
                                            <label 
                                                className="ns-label ns-checkboxes__label"
                                                id={"collectors-checkbox-label-" + index}
                                                key={"collectors-checkbox-label-" + index} 
                                                htmlFor={"collectors-checkbox-input-" + index}>
                                                <span className="ns-label-span">{c.contactName}</span>
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </fieldset>
                    </div>
                </div> : 
                <div className="row">
                    <div className="col-8 centered">
                        <p className="statusText">
                            {`(no ${applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT ? 'debt management agent' : 'collector'} to renew)`}
                        </p>
                    </div>
                </div>
                }
                <div className="row">
                    <Button
                            id="collectors-review-save-next-button"
                            buttonType={"regular_primary"}
                            text={"Save and next"}
                            onClick={() => {
                                const agentApplicationIdsToRenew = []
                                const agentApplicationIdsToNotRenew = []

                                collectorsCheckboxMapping.forEach((c, index) => {
                                    if(c) { 
                                        agentApplicationIdsToRenew.push(collectors[index].id)
                                    } else {
                                        agentApplicationIdsToNotRenew.push(collectors[index].id)
                                    }
                                })

                                const promiseArrays = []

                                if(agentApplicationIdsToRenew.length > 0) {
                                    promiseArrays.push(dispatch(renewIndividualApplications(agentApplicationIdsToRenew)))
                                }
                                
                                if(agentApplicationIdsToNotRenew.length > 0) {
                                    promiseArrays.push(dispatch(doNotRenewIndividualApplications(agentApplicationIdsToNotRenew)))
                                }

                                if(promiseArrays.length > 0) {
                                    Promise.all(promiseArrays)
                                    .then(() => {
                                        dispatch(syncRjscDetailsForIndividualApplications(agentApplicationIdsToRenew)).then(data => {
                                            dispatch(push(replaceUrlParams(
                                                collectorsReviewViewData.navigation.next,applicationType, applicationMode)))
                                        })
                                        .catch(err => console.error("could not sync individual applications"))
                                    })
                                    .catch(err => console.error("error in setting renewal params for individual applications"))
                                } else {
                                    dispatch(push(replaceUrlParams(collectorsReviewViewData.navigation.next,applicationType, applicationMode)))
                                }
                            }}
                        />
                </div>
            </div>
        </div>
    )
}

export default connect(collectorsReviewSelect)(CollectorsReview)
